import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { createBillingEntity } from "api/services/billingEntity";
import DrawerWrapper from "components/DrawerWrapper";
import { snack } from "components/toast";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import { DialogProps } from "types";
import {
  createBillingDefaultValues,
  CreateBillingSchema,
} from "validations/createBilling";
import GstVerify from "./GstVerify";
import PanDetails from "./PanVerify";
import { handleChange } from "redux/reducers/billingEntitySlice";
import { useDispatch } from "react-redux";

interface Props extends DialogProps {
  embedded?: boolean;
  onSuccess?: () => void;
}

const AddBillingEntities = ({ open, setOpen, embedded, onSuccess }: Props) => {
  const queryClient = useQueryClient();
  const [isGstRegistered, setIsGstRegistered] = useState("");
  const dispatch = useDispatch();

  const { mutate, isLoading } = useMutation(createBillingEntity, {
    onSuccess: () => {
      snack.success("Billing Entity Created");
      queryClient.invalidateQueries("billing-entities");
      setOpen(false);

    },

    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });

  const { control, handleSubmit, reset } = useForm({
    defaultValues: createBillingDefaultValues,
    mode: "onChange",
    resolver: yupResolver(CreateBillingSchema),
  });

  const onFormSubmit = (data: any) => {
    mutate(data);

  };

  const RadioValue = (e: any) => {
    setIsGstRegistered(e.target.value);
    if (e.target.value === 'Yes') {
      dispatch(handleChange({ key: 'isGst', value: true }));
    } else if (e.target.value === 'No') {
      dispatch(handleChange({ key: 'isGst', value: false }));
    }
  };

  const content = (
    <Box mt={embedded ? 0 : 3}>
      <FormControl>
        <FormLabel>Is Billing Entity registered under GST?</FormLabel>
        <RadioGroup row>
          <FormControlLabel
            onChange={RadioValue}
            value="Yes"
            control={<Radio />}
            label="Yes"
          />
          <FormControlLabel
            onChange={RadioValue}
            value="No"
            control={<Radio />}
            label="No"
          />
        </RadioGroup>
      </FormControl>
      {isGstRegistered === "Yes" && <GstVerify setOpen={setOpen} onSuccess={onSuccess} />}
      {isGstRegistered === "No" && <PanDetails setOpen={setOpen} onSuccess={onSuccess} />}
    </Box>
  );

  if (embedded) return content;

  return (
    <DrawerWrapper open={open} setOpen={setOpen} title="Billing Entity">
      {content}
    </DrawerWrapper>
  );
};
export default AddBillingEntities;
